import { translate } from '@jsverse/transloco';
export enum StatusReportType {
    NONE = 'NONE',
    PCI_V4 = 'PCI_V4',
}

export class StatusReportTypeHelper {
    static getStatusReportTypeLocale(statusReportType: StatusReportType): string {
        switch (statusReportType) {
            case StatusReportType.NONE:
                return translate('STATUS_REPORT_TYPE.NONE');
            case StatusReportType.PCI_V4:
                return translate('STATUS_REPORT_TYPE.PCI_DSS_V4');
            default:
                return statusReportType;
        }
    }
}
